export const NATURAL_GAS_PROVIDERS_NAMES = {
  EDP: "EDP",
  endesa: "Endesa",
  government: "Gobierno",
  iberdrola: "Iberdrola",
  naturgy: "Naturgy",
  repsol: "Repsol",
};
